import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL + '/api/v1',
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (res) => res,
  (error) => {

    
    if (error.response?.data?.message === 'Unauthorized') {
      localStorage.removeItem('token')
      //window.location.href = '/register'
    }
    return Promise.reject(error)
  },
)

export default api
